import Slideshow from "../../classes/Slideshow";
import {scrollPageFromCookie} from "../../../utils/scrollPageFromCookie";

export const initConstructionProgress = () => {
	const components = Array.from( document.querySelectorAll( 'section.construction-progress' ));
	
	if ( components.length )
	{
		components.forEach( ( component ) => {
			const slider = component.querySelector( 'div.slideshow' );
			
			if ( slider )
			{
				const bookmarksContainer = slider.querySelector( 'ul.buttons' );
				const slidesContainer = slider.querySelector( 'ul.slides' );
				const navsContainer = slider.querySelector( 'ul.nav' );

				if ( bookmarksContainer || navsContainer)
				{
					new Slideshow({
						slidesContainer,
						bookmarksContainer,
						navsContainer,
					});
				}
			}

			const progressPercentSpan = component.querySelector( 'div.percent > p > span.factoid' );
			const progressPercent = progressPercentSpan.getAttribute( 'data-progress' );
			const progressLine = component.querySelector( 'div.progress > span' );

			if ( progressLine )
			{
				if ( progressPercent < 5 ) {
					progressLine.style.width = '5%';
					progressPercentSpan.textContent = '5% построено';
				}
				else
				{
					progressLine.style.width = `${progressPercent}%`;
				}
			}

			component.querySelectorAll( 'ul.cards > li' ).forEach( ( elem ) => {
				elem.addEventListener( 'click', () => {
					document.cookie = `scroll=${window.scrollY}`;
				} )
			});

			scrollPageFromCookie();
		});
	}
}
